import { isIOS, isIPadOS } from "./IOSDetections";
import { canUseDOM } from "./dom";
var detect = /*#__PURE__*/ function() {
    var obj = {
        hasMouse: false,
        hasTouchEvents: false,
        hasHover: false,
        hasTouch: false
    };
    if (!canUseDOM) {
        return obj;
    }
    if (isIOS && !isIPadOS) {
        obj.hasMouse = false;
        obj.hasHover = false;
        obj.hasTouchEvents = true;
        obj.hasTouch = true;
    } else {
        obj.hasTouchEvents = "ontouchstart" in document;
        obj.hasTouch = obj.hasTouchEvents || "maxTouchPoints" in navigator && navigator.maxTouchPoints > 0;
        if (obj.hasTouch) {
            var notMobile = !/android|mobile|tablet/i.test(navigator.userAgent);
            obj.hasMouse = typeof window.matchMedia === "function" && window.matchMedia("(pointer)").matches ? matchMedia("(pointer: fine)").matches : notMobile;
            obj.hasHover = obj.hasMouse && (typeof window.matchMedia === "function" && window.matchMedia("(hover)").matches ? matchMedia("(hover: hover)").matches : notMobile);
        } else {
            obj.hasMouse = true;
            obj.hasHover = true;
        }
    }
    return obj;
}();
export var hasMouse = /*#__PURE__*/ function() {
    return detect.hasMouse;
}();
export var hasHover = /*#__PURE__*/ function() {
    return detect.hasHover;
}();
export var hasTouchEvents = /*#__PURE__*/ function() {
    return detect.hasTouchEvents;
}();
export var hasTouch = /*#__PURE__*/ function() {
    return detect.hasTouch;
}();

//# sourceMappingURL=InputUtils.js.map